export default __webpack_public_path__ + "static/media/c_7.e0ecbffc.svg";